"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("D:\\\u9879\u76EE\u7BA1\u7406\\\u65E7\u6362\u65B0\\\u6E90\u7801\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\@babel\\runtime\\regenerator\\index.js"));

var _dashboard = require("@/api/dashboard");

var _index2 = _interopRequireDefault(require("@/components/echarts/index"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = {
  name: 'user-chart',
  components: {
    echartsFrom: _index2.default
  },
  data: function data() {
    return {
      line: 'line',
      circle: 'circle',
      xAxis: [],
      infoList: {},
      series: [],
      xData: [],
      y1Data: [],
      y2Data: [],
      lists: [],
      bing_data: [],
      bing_xdata: [],
      legendData: [],
      seriesUser: [],
      chartBuy: {}
    };
  },
  methods: {
    // 统计
    getStatistics: function getStatistics() {
      var _this = this;

      (0, _dashboard.chartUserApi)().then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee(res) {
          var data, key;
          return _index.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.infoList = res;
                  data = [];

                  for (key in res) {
                    data.push(res[key]);

                    _this.xAxis.push(key);
                  }

                  _this.series = [{
                    data: data,
                    name: '人数（人）',
                    type: 'line',
                    tooltip: true,
                    smooth: true,
                    symbol: 'none',
                    areaStyle: {
                      normal: {
                        opacity: 0.2
                      }
                    }
                  }]; // this.bing_data = res.bing_data;
                  // this.bing_xdata = res.bing_xdata;

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 监听页面宽度变化，刷新表格
    handleResize: function handleResize() {
      if (this.infoList && this.series.length !== 0) this.$refs.userChart.handleResize();
      if (this.infoList) this.$refs.visitChart.handleResize();
    }
  },
  mounted: function mounted() {
    this.getStatistics();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.visitChart) {
      this.visitChart.dispose();
      this.visitChart = null;
    }
  }
};
exports.default = _default;